
import CompanyMap from "@/components/CompanyMap.vue";
export default {
  data() {
    return {
      companyData: {
        osaka: {
          id: 1,
          title: "本社リビング・大阪第一開発支社",
          postID: "550-0014",
          adress: "大阪市西区北堀江1-6-2 サンワールドビル5F",
          mapURL:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13124.836564693267!2d135.47819732010663!3d34.67467070954666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e70533d33f2f%3A0xcdaf27ab3f52214d!2z5qCq5byP5Lya56S-IOadkeeUsOOCveODleODiOOCpuOCp-OCouOCteODvOODk-OCuQ!5e0!3m2!1sja!2sjp!4v1710225962752!5m2!1sja!2sjp",
        },
        osaka2: {
          id: 3,
          title: "大阪第二開発支社",
          postID: "550-0014",
          adress: "大阪府大阪市西区北堀江1丁目5-2 四ツ橋新興産ビル706",
          mapURL:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.238762702599!2d135.496481!3d34.673922999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6000e7054edf0b41%3A0x31c36554ec2aca07!2z44CSNTUwLTAwMTQg5aSn6Ziq5bqc5aSn6Ziq5biC6KW_5Yy65YyX5aCA5rGf77yR5LiB55uu77yV4oiS77ySIOWbm-ODhOapi-aWsOiIiOeUo-ODk-ODqyA3MDY!5e0!3m2!1sja!2sjp!4v1712899559859!5m2!1sja!2sjp",
        },
        tokyo: {
          id: 2,
          title: "東京支社",
          postID: "160-0023",
          adress: "東京都新宿区西新宿7丁目1-12",
          mapURL:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d810.0699323049954!2d139.69835136971548!3d35.69473338744747!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188cd7ca5b2f83%3A0xef251056025b6958!2z44CSMTYwLTAwMjMg5p2x5Lqs6YO95paw5a6_5Yy66KW_5paw5a6_77yX5LiB55uu77yR4oiS77yR77yS!5e0!3m2!1sja!2sjp!4v1770250321115!5m2!1sja!2sjp",
        },
      },
      historyEvents: [
        { date: '1995年', description: '村田ソフトウェアサービスを創業。' },
        { date: '1999年', description: '事業拡大に伴い法人化。有限会社村田ソフトウェアサービスとなる。' },
        { date: '2000年', description: '「株式会社村田ソフトウェアサービス」となる。' },
        { date: '2001年', description: '資本金を2,000万円に増資。更なる発展を目指す。' },
        { date: '2005年', description: '技術者育成事業として、有限会社プロルートを設立。' },
        { date: '2005年', description: '資本金を2,512万円に増資。更なる飛躍を目指す。' },
        { date: '2006年', description: '「有限会社プロルート」を<a href="https://www.pro-route.jp/">株式会社プロルート</a>に組織変更。' },
        { date: '2013年', description: '業務拡大のため、東京第1開発ルームを開設。' },
        { date: '2020年', description: 'コロナのパンデミック宣言に伴いリモートワークを導入。' },
        { date: '2024年', description: '受託案件増加のため、大阪第2開発ルームを開設。' },
        { date: '2024年', description: '採用強化のため、大阪本社を増床。' },
        { date: '2025年', description: '本社をリニューアル。' },
        { date: '2026年', description: '東京支社拡大に伴い移転。' },
      ],
      mainClients: [
        { name: '株式会社モンベル' },
        { name: '株式会社USEN' },
        { name: '千代田化工建設株式会社' },
        { name: '学校法人駿河台学園' },
        { name: 'SATT株式会社' },
        { name: '株式会社キャリカレ' },
        { name: '株式会社ボトルキューブ' },
        { name: '三信電気株式会社' },
        { name: '株式会社サファリゲームズ' },
        { name: '株式会社ニューロン・エイジ' },
        { name: '株式会社BTM' }
      ],
    };
  },
  components: {
    CompanyMap,
  },
  metaInfo() {
    return {
      title: '会社概要 | 株式会社村田ソフトウェアサービス',
      meta: [
        {
          name: 'description',
          content: '株式会社村田ソフトウェアサービスの会社概要ページです。'
        },
      ],
    };
  },
};
